<template>
  <DialogLayout
    title="新規取込"
    :visible.sync="dialogVisible"
    width="55em"
    @open="open"
  >
    <template #form>
      <ImportForm
        ref="importForm"
        v-model="importFormModel"
        action="/import-registration-symbol"
        label="登録機データファイル"
        extension="csv|txt"
        @import-success="importSuccess"
        @import-error="importError"
     />
    </template>
    <template #footer>
      <ImportDialogFooter
        @import="clickImport"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import ImportForm from '@/components/organisms/dialog/ImportForm.vue'
import ImportDialogFooter from '@/components/organisms/dialog/ImportDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    ImportForm,
    ImportDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      importFormModel: {
        data_capture: '2'
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickImport () {
      this.$loadingMask.on()
      this.$refs.importForm.validate()
        .then((res) => {
          this.$refs.importForm.import()
        })
        .catch((e) => {
          console.log(e)
          this.$loadingMask.off()
        })
    },
    importSuccess (res) {
      this.dialogVisible = false
      this.$fcMessage.showMessage(res.data.message)
      this.$emit('refresh')
    },
    importError (res) {
      switch (res.status) {
        case 402:
          this.$fcMessage.showMessage({
            id: 'CMN0033E',
            link: {
              fileName: 'error.txt',
              messages: res.data.message
            }
          }, true)
          break
        default:
      }
      this.$loadingMask.off()
    },
    open () {
      this.$nextTick(function () {
        this.$refs.importForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
